import * as React from 'react'
import { connect } from 'react-redux'

import { anchorClick } from 'embed/actions'

interface Props {
  dispatchAnchorClick: (href) => void
}

export const AnchorInterceptor: React.FunctionComponent<Props> = ({ children, dispatchAnchorClick }) => {
  const handleClick = React.useCallback(
    (e) => {
      if (e.target.tagName === 'A' && e.target.href) {
        dispatchAnchorClick(e.target.href)
      }
    },
    [dispatchAnchorClick],
  )

  return <div onClick={handleClick}>{children}</div>
}

export const mapDispatchToProps = (dispatch) => ({
  dispatchAnchorClick: (href) => dispatch(anchorClick(href)),
})

export default connect(undefined, mapDispatchToProps)(AnchorInterceptor)
